module.exports = __webpack_public_path__ + "static/media/buy_payment_6.711fcaa9.jpg";